import React, { useEffect, useState } from "react";
import {
	Box,
	Typography,
	TextField,
	Select,
	MenuItem,
	Button,
	CircularProgress,
	FormControlLabel,
	Switch,
	Paper,
} from "@mui/material";
import supabase from "../../../supabaseClient";

const BANNER_COLOR_OPTIONS = [
	{ value: "light_green", label: "Light Green" },
	{ value: "light_yellow", label: "Light Yellow" },
	{ value: "light_red", label: "Light Red" },
	{ value: "light_blue", label: "Light Blue" },
	{ value: "light_purple", label: "Light Purple" },
];

export default function AdminManageBanner() {
	const [loading, setLoading] = useState(true);
	const [saving, setSaving] = useState(false);
	const [form, setForm] = useState({
		singleton: true,
		message: "",
		color_option: "light_yellow",
		is_enabled: true,
	});

	const fetchBannerSettings = async () => {
		setLoading(true);
		const { data, error } = await supabase
			.from("site_banner_settings")
			.select("singleton, message, color_option, is_enabled")
			.eq("singleton", true)
			.maybeSingle();

		if (error) {
			alert(`Error loading banner settings: ${error.message}`);
		} else if (data) {
			setForm({
				singleton: true,
				message: data.message || "",
				color_option: data.color_option || "light_yellow",
				is_enabled: data.is_enabled ?? true,
			});
		}
		setLoading(false);
	};

	useEffect(() => {
		fetchBannerSettings();
	}, []);

	const handleSave = async () => {
		setSaving(true);
		const payload = {
			singleton: true,
			message: form.message,
			color_option: form.color_option,
			is_enabled: form.is_enabled,
			updated_at: new Date().toISOString(),
		};

		const { error } = await supabase
			.from("site_banner_settings")
			.upsert(payload, { onConflict: "singleton" });

		if (error) {
			alert(`Error saving banner settings: ${error.message}`);
		} else {
			alert("Banner settings saved.");
		}
		setSaving(false);
	};

	return (
		<Box sx={{ mx: "auto", width: "100%" }}>
			<Typography variant="h5" gutterBottom>
				Manage Header Banner
			</Typography>
			<Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
				If the banner message is empty, it will not be shown on the site.
			</Typography>

			{loading ? (
				<CircularProgress />
			) : (
				<Paper sx={{ p: 2 }}>
					<TextField
						label="Banner Message"
						value={form.message}
						onChange={(e) => setForm({ ...form, message: e.target.value })}
						placeholder="e.g. Closed for the winter. Back in May 2027!"
						fullWidth
						multiline
						minRows={2}
						sx={{ mb: 2 }}
					/>

					<Typography variant="subtitle2" sx={{ mb: 1 }}>
						Banner Color
					</Typography>
					<Select
						fullWidth
						size="small"
						value={form.color_option}
						onChange={(e) => setForm({ ...form, color_option: e.target.value })}
						sx={{ mb: 2 }}
					>
						{BANNER_COLOR_OPTIONS.map((option) => (
							<MenuItem key={option.value} value={option.value}>
								{option.label}
							</MenuItem>
						))}
					</Select>

					<FormControlLabel
						control={
							<Switch
								checked={form.is_enabled}
								onChange={(e) =>
									setForm({ ...form, is_enabled: e.target.checked })
								}
							/>
						}
						label="Enable banner"
						sx={{ mb: 2, display: "block" }}
					/>

					<Button variant="contained" onClick={handleSave} disabled={saving}>
						{saving ? "Saving..." : "Save Banner Settings"}
					</Button>
				</Paper>
			)}
		</Box>
	);
}
